import QuestionInputSelect from "./QuestionInputSelect";
import GelHackButton from "../gel/GelHackButton";
import common from "../../common";
import GelButton from "../gel/GelButton";

export default class QuestionInputSelectClockFace extends QuestionInputSelect {
    constructor(question, view) {
        super(question, view);

    }

	selectOption(option) {
		this._selected = option;
		this._selected.alpha = 0.3;
		//this._selected._currentNormalTexture = P3.assets.texture("ui_drop_in_area_selected");

		const value = this._selected.value;
		this._view.setAnswer(value);
	}

	deselectOption(option) {
		this._selected.alpha =1;
		//this._selected._currentNormalTexture = P3.assets.texture("ui_drop_in_area");
		this._selected.onMouseOut({});
		this._selected = null;
	}

	createOptionButton(value) {
		const button = GelHackButton.create(P3.assets.texture("clock_face_base"));
		button.value = value;
		button.animate = false;
		button.animateIcon = false;
		button.tint = common.config.debug && button.value === this._question.answer ? 0x00AA00 : 0xFFFFFF;
		button.scale.set(0.7);

		button.hourHand = new PIXI.Sprite(P3.assets.texture('clock_face_shorthand'));
		button.hourHand.anchor.set(0.5);
		button.hourHand.scale.set(0.85);
		button.hourHand.position.set(0, 0);
		button.addChild(button.hourHand);

		button.minuteHand = new PIXI.Sprite(P3.assets.texture('clock_face_longhand'));
		button.minuteHand.anchor.set(0.5);
		button.minuteHand.scale.set(0.85);
		button.minuteHand.position.set(0, 0);
		button.addChild(button.minuteHand);


		let h = 360 / 12;
		let m = 360 / 60;

		console.log(value.value);

		button.hourHand.rotation = ((h * value.value[0]) + ((value.value[1] * 360/60)/12)) * PIXI.DEG_TO_RAD;
		button.minuteHand.rotation = (m * value.value[1]) * PIXI.DEG_TO_RAD;

		for (let j = 1; j <= 12; j++) {
			const angleStep = 360 / 12;
			const angle = -180 + (j * angleStep);
			const x = (58 * Math.sin(angle * PIXI.DEG_TO_RAD)) * -1;
			const y = 58 * Math.cos(angle * PIXI.DEG_TO_RAD);

			let t = new PIXI.Text((j).toString(), {
				fontSize: "15px", fontFamily: "Arial", fontWeight: "bold", fill: 0x0});
			t.position.set(x, y);
			t.anchor.set(0.5, 0.5);
			t.resolution = 2;
			button.addChild(t);
		}
		return button;
	}

	createOptionButtons(options) {
    	super.createOptionButtons(options);
    	this._buttonsContainer.x -= 15;

		for (let i = 0; i < this._buttonsContainer.children.length / 2; i++) {
			this._buttonsContainer.children[i].visible = false;
		}
	}
}